import type { CatalogRatioData } from '@gql/graphql';

import { Checkbox } from '@consta/uikit/Checkbox';

import Styles from '../../massRatioApplication.module.css';

interface UpdateBaseCostRatioRowData extends CatalogRatioData {
    groupRow?: boolean;
}

interface IRatiosTableCellRenderCheckboxProps {
    checkedIds: Record<string, CatalogRatioData | null>;
    data: UpdateBaseCostRatioRowData;
    handleChangeCheckbox: (row: CatalogRatioData) => ({ checked }: { checked: boolean }) => void;
    getCanCheckRow?: (data: CatalogRatioData) => boolean;
}

export const RatiosTableCellRenderCheckbox = (props: IRatiosTableCellRenderCheckboxProps) => {
    const { checkedIds, data, handleChangeCheckbox, getCanCheckRow } = props;

    const currentChecked = !!checkedIds[data?.id];
    const currentChange = handleChangeCheckbox(data);

    const canCheck = getCanCheckRow ? getCanCheckRow(data) : true;

    return (
        <div className="CheckboxWrapper">
            <Checkbox
                className={Styles.checkboxFocus}
                checked={currentChecked}
                onChange={currentChange}
                disabled={!canCheck}
            />
        </div>
    );
};

RatiosTableCellRenderCheckbox.displayName = 'RatiosTableCellRenderCheckbox';
